// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dQgp","left":"styles_left__1o9b6"};